import {
  SET_LOADING,
} from 'constants/LoaderConstant';

const initialState = {
  align: 'center',
  cover: 'inline'
}
const theme = (state = initialState, action) => {
  switch (action.type) {
  case SET_LOADING:
    return {
      ...state,
      ...action.payload
    };
  default:
    return state;
  }
};

export default theme